module.exports = __webpack_public_path__ + "static/media/7.bd6c742b.png";